import React, { useState, useEffect } from 'react';
import { useStateValue } from "../StateProvider";
import { Link as RouterLink } from "react-router-dom";
import { firestoreV9, collection, query } from '../firebase';
import { getDocs } from 'firebase/firestore';
import "./BlogSongs.css";
import BlogSongBox from "./BlogSongBox";

function BlogSongsBody() {
  const [{ songToPlay }, dispatch] = useStateValue();
  const [blogSongs, setBlogSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGenre, setSelectedGenre] = useState("All Genres");
  const [availableGenres, setAvailableGenres] = useState([]);

  // Fetch blog songs from Firestore
  useEffect(() => {
    const fetchBlogSongs = async () => {
      try {
        const blogSongsRef = collection(firestoreV9, "blogSongs");
        const blogSongsQuery = query(blogSongsRef);
        const snapshot = await getDocs(blogSongsQuery);

        const songs = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setBlogSongs(songs);

        // Extract unique genres from all songs
        const genresSet = new Set();
        songs.forEach(song => {
          if (song.genres && Array.isArray(song.genres)) {
            song.genres.forEach(genre => genresSet.add(genre));
          }
        });

        const genresArray = Array.from(genresSet).sort();
        setAvailableGenres(genresArray);

        setLoading(false);
      } catch (err) {
        console.error('Error fetching blog songs:', err);
        setLoading(false);
      }
    };

    fetchBlogSongs();
  }, []);

  // Filter songs based on selected genre
  const filteredSongs = selectedGenre === "All Genres"
    ? blogSongs
    : blogSongs.filter(song =>
        song.genres && song.genres.includes(selectedGenre)
      );

  // Handle click on "here" link - same behavior as Carousel navigation
  const handleCarouselLinkClick = () => {
    // Close mobile menu when navigating
    dispatch({
      type: "SET_STATEMOBILEMENU",
      isOpen: false,
    });

    // Only reset playBlocker if there's no active song
    if (!songToPlay || songToPlay === "0") {
      dispatch({
        type: "SET_PLAYBLOCKER",
        playBlocker: null,
      });
    }

    // Ensure player button is available when navigating to carousel
    dispatch({
      type: "SET_SHOWINITIALIZEPLAYERBUTTON",
      showInitializePlayerButton: 1,
    });

    // Reset menustate to carousel when navigating home
    dispatch({
      type: "SET_MENUSTATE",
      menustate: "feedbackcarouselmenu",
    });

    // Reset DB read permission for menu navigation
    dispatch({
      type: "SET_DBLESENCOMINGMENU",
      dblesencomingfrommenu: 1,
    });
  };

  return (
    <div className="blogSongsBody">
      <h1>Here are some cool songs we discovered on Song Carousel or on other places.</h1>

      {/* Genre Filter */}
      <div className="genreFilter">
        <label htmlFor="genreSelect">Filter by Genre: </label>
        <select
          id="genreSelect"
          value={selectedGenre}
          onChange={(e) => setSelectedGenre(e.target.value)}
          className="genreSelect"
        >
          <option value="All Genres">All Genres</option>
          {availableGenres.map(genre => (
            <option key={genre} value={genre}>{genre}</option>
          ))}
        </select>
      </div>

      {/* Loading state */}
      {loading && <p>Loading songs...</p>}

      {/* Blog Songboxes */}
      <div className="blogSongsGrid">
        {filteredSongs.length > 0 ? (
          filteredSongs.map(song => (
            <BlogSongBox key={song.id} song={song} trackId={song.id} />
          ))
        ) : (
          !loading && <p>No songs available for this genre.</p>
        )}
      </div>

      {/* Teaser */}
      <div className="blogTeaser">
        <p>
          Do you want to see your song here? Listen and rate some songs{" "}
          <RouterLink to="/" onClick={handleCarouselLinkClick} className="teaserLink">here</RouterLink> and add your song.
          And maybe you will see it here soon :)
        </p>
      </div>

      {/* Removal text */}
      <div className="blogRemovalText">
        <p>Want your song removed? Write to info 'at' catchyrecords.com.</p>
      </div>
    </div>
  );
}

export default BlogSongsBody;
